import type { OrderEntity } from '@/features/order/domain/entities/OrderEntity'

export class OrdersStreamEntity {
  orders: OrderEntity[] = []
  showCompletedOrderDurationInSecond: number = 0
  showCanceledOrderDurationInSecond: number = 0
}
